<template>
  <v-card style="height: 100%" v-if="product">
    <img
      :src="product.photourl"
      style="width: 100%"
      @click="zoomImage(product.photourl)"
    />
    <v-card-text class="pa-2">
      <div :style="{ color: theme.color }" class="title mb-1">
        {{ product.name }}
      </div>
      <template v-for="(stock, sindex) in product.productstock">
        <v-layout
          v-if="stock[1] == 'ขวดเล็ก'"
          :key="'stock_' + product.id + '_' + stock[0] + '_' + sindex"
        >
          <v-flex class="py-2 subheading">ขวดเล็ก</v-flex>
          <v-flex
            style="white-space: nowrap"
            shrink
            class="text-xs-center text-sm-right"
          >
            <v-btn
              style="width: 30px; height: 30px"
              class="ma-1"
              small
              flat
              fab
              outline
              :key="'remove_small_stock_' + product.id"
              :disabled="product.bottle.small <= 0"
              @click="onChangeStock('small', -1)"
              ><v-icon small>mdi-minus</v-icon></v-btn
            >
            <span
              class="subheading"
              :class="{
                'red--text':
                  totalBottle[product.type.toLowerCase()] &&
                  bottle[product.type.toLowerCase()] &&
                  (totalBottle[product.type.toLowerCase()].small >=
                    bottle[product.type.toLowerCase()].smallbottles ||
                    parseInt(stock[2]) <= product.bottle.small)
              }"
            >
              {{ product.bottle.small }}</span
            >
            <v-btn
              style="width: 30px; height: 30px"
              class="ma-1"
              small
              flat
              fab
              outline
              :key="'add_small_stock_' + product.id"
              @click="onChangeStock('small', 1)"
              :disabled="
                bottle[product.type.toLowerCase()] &&
                parseInt(stock[2]) <= product.bottle.small
              "
              ><v-icon small>mdi-plus</v-icon></v-btn
            >
          </v-flex>
          <v-flex xs12 v-if="false">
            <div>Type: {{ product.type }}</div>
            <v-divider />
            totalBottle: {{ totalBottle }}
            <v-divider />
            <div v-if="totalBottle[product.type]">
              {{ totalBottle[product.type].small }}
            </div>
            <v-divider />
            bottle: {{ bottle }}
            <v-divider />
            <div v-if="bottle[product.type]">
              {{ bottle[product.type].smallbottles }}
            </div>
            <v-divider />
          </v-flex>
        </v-layout>
        <v-layout
          v-if="stock[1] == 'ขวดใหญ่'"
          :key="'stock_' + product.id + '_' + stock[0] + '_' + sindex"
        >
          <v-flex class="py-2 subheading">ขวดใหญ่</v-flex>

          <v-flex
            style="white-space: nowrap"
            shrink
            class="text-xs-center text-sm-right"
          >
            <v-btn
              style="width: 30px; height: 30px"
              class="ma-1"
              small
              flat
              fab
              outline
              :disabled="product.bottle.large <= 0"
              @click="onChangeStock('large', -1)"
              ><v-icon>mdi-minus</v-icon></v-btn
            >

            <span
              class="subheading"
              :class="{
                'red--text':
                  totalBottle[product.type.toLowerCase()] &&
                  bottle[product.type.toLowerCase()] &&
                  (totalBottle[product.type.toLowerCase()].large >=
                    bottle[product.type.toLowerCase()].bigbottles ||
                    parseInt(stock[2]) <= product.bottle.large)
              }"
            >
              {{ product.bottle.large }}</span
            >

            <v-btn
              style="width: 30px; height: 30px"
              class="ma-1"
              small
              flat
              fab
              outline
              @click="onChangeStock('large', 1)"
              :disabled="
                bottle[product.type.toLowerCase()] &&
                parseInt(stock[2]) <= product.bottle.large
              "
              ><v-icon>mdi-plus</v-icon></v-btn
            >
          </v-flex>
        </v-layout>
      </template>
    </v-card-text>
    <v-dialog scrollable v-model="showZoomImage" max-width="690">
      <v-card v-if="currentZoomImage">
        <v-card-actions class="text-xs-right">
          <v-layout>
            <v-flex>
              <v-btn
                flat
                fab
                icon
                small
                @click="
                  showZoomImage = false
                  currentZoomImage = null
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
        <v-card-text class="pa-0 text-xs-center">
          <v-zoom
            :img="currentZoomImage"
            :width="'100%'"
            style="margin: auto"
          ></v-zoom>
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import vZoom from 'vue-zoom'
export default {
  props: ['value', 'totalBottle', 'bottle'],
  data() {
    return {
      product: this.value,
      showZoomImage: false,
      currentZoomImage: null
    }
  },
  components: {
    vZoom
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    })
  },
  methods: {
    async onChangeStock(type, count) {
      let val = this.product.bottle[type] + count
      this.$set(this.product.bottle, type, val)
      this.$emit('changeBottle')
    },
    zoomImage(image) {
      if (image) {
        this.currentZoomImage = image
        this.showZoomImage = true
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
